<template>
  <div class="rounded-lg border py-3 px-4 flex items-start space-x-4" :class="[bgColorClass]">
    <div class="flex-none pt-[2px]">
      <component v-bind="iconAttrs" :is="iconComponent" :class="[ICON_COLOR_MAP[variant], 'fill-current']" />
    </div>
    <div class="flex-1 text-sm"><slot v-bind="$attrs" /></div>
  </div>
</template>

<script lang="ts">
export const FEEDBACK_VARIANTS = {
  error: 'error',
  info: 'info',
  success: 'success',
  warning: 'warning',
  neutral: 'neutral',
};
</script>

<script setup lang="ts">
import { computed } from 'vue';

import { IconWarning, IconDanger, IconApprove, IconInfo } from '../icons';

const BG_COLOR_MAP = {
  [FEEDBACK_VARIANTS.error]: 'bg-red-100',
  [FEEDBACK_VARIANTS.info]: 'bg-primary-100',
  [FEEDBACK_VARIANTS.success]: 'bg-success-100',
  [FEEDBACK_VARIANTS.warning]: 'bg-warning-100',
  [FEEDBACK_VARIANTS.neutral]: 'bg-neutral-100',
};

const ICON_COMPONENT_MAP = {
  [FEEDBACK_VARIANTS.error]: IconDanger,
  [FEEDBACK_VARIANTS.info]: IconInfo,
  [FEEDBACK_VARIANTS.success]: IconApprove,
  [FEEDBACK_VARIANTS.warning]: IconWarning,
  [FEEDBACK_VARIANTS.neutral]: IconInfo,
};

const ICON_COLOR_MAP = {
  [FEEDBACK_VARIANTS.error]: 'text-red-700',
  [FEEDBACK_VARIANTS.info]: 'text-primary-700',
  [FEEDBACK_VARIANTS.success]: 'text-success-700',
  [FEEDBACK_VARIANTS.warning]: 'text-warning-700',
};

const props = defineProps({
  variant: {
    default: FEEDBACK_VARIANTS.info,
    type: String,
    validator: (variant: string) => Object.values(FEEDBACK_VARIANTS).includes(variant),
  },
  iconAttrs: {
    default: () => ({}),
    type: Object,
  },
});

const iconComponent = computed(() => ICON_COMPONENT_MAP[props.variant]);
const bgColorClass = computed(() => BG_COLOR_MAP[props.variant]);
</script>
